import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PageLayoutService } from '@spartacus/storefront';
import { map } from 'rxjs';
import { Page } from '@spartacus/core';

@Component({
  selector: 'page-title',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './page-title.component.html',
  styleUrl: './page-title.component.scss',
})
export class PageTitle {
  @Input() classList = '';
  @Input() isBackButtonVisible: boolean = false;
  @Input() backButtonTitle: string = 'Back';
  @Input() backButtonRedirectPage = '';
  @Input() pageTitle = '';

  title$ = this.pageLayoutService.page$.pipe(
    map((page: Page) => {
      return page.title;
    }),
  );

  constructor(private pageLayoutService: PageLayoutService) {}
}
